<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">公司企业网站模板</p>
    <p class="address_tel_fax">
      <span>地址：公司地址公司地址公司地址公司地址</span>
      <span>Tel：888-888-888</span>
      <span>Fax：8888-88888888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：xxxxx@163.com</span>
      <span>公司微信号：xxxx</span>
    </p>
    <p class="copy">
      <span>Copyright &copy; 2018 - 2019 公司名称公司名称</span>
      <spen class="left20">
        <a href="https://beian.miit.gov.cn">桂ICP备2022004552号</a>
      </spen>
      <span class="left20" style="vertical-align:middle">
        <img class="ga_beian_img" src="@/assets/img/ga_beian.png">
        <a style="margin-left: 20px;"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=45092402000157">桂公网安备45092402000157</a>
      </span>
    </p>
  </div>
</template>
<script>
  export default {
    name: "Footer",
    data() {
      return {};
    }
  };
</script>
<style scoped>
  .ga_beian_img {
    position: absolute;
    left: 0px;
    top: -2px;
    height: 18px;
    width: 17px;
  }

  .left20 {
    position: relative;
    margin-left: 20px;
  }

  #footer {
    width: 100%;
    height: 100%;
    color: #fff;
    background: #474747;
    overflow: hidden;
    text-align: center;
  }

  .logo {
    width: 95px;
    height: 45px;
    margin: 50px auto 20px;
  }

  .title {
    font-size: 25px;
    margin-bottom: 20px;
  }

  .address_tel_fax {
    color: #d3d3d3;
    font-size: 14px;
    margin: 10px 0;
  }

  .email_wx {
    color: #d3d3d3;
    font-size: 14px;
  }

  .copy {
    color: #d3d3d3;
    font-size: 14px;
    margin: 50px 0 10px;
  }

  @media screen and (max-width: 997px) {
    .title {
      font-size: 20px;
    }

    .address_tel_fax {
      font-size: 12px;
    }

    .email_wx {

      font-size: 12px;
    }

    .copy {
      font-size: 12px;
      margin: 30px 0 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue